<template>
  <v-navigation-drawer
    bottom
    color="transparent"
    fixed
    height="auto"
    overlay-color="secondary"
    overlay-opacity=".8"
    temporary
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list
      color="white"
      shaped
    >
      <template v-for="(item, index) in items">
        <v-list-group
          v-if="item.children && item.children.length"
          :key="`group-${item.id || item.src || item.i18n || index}`"
        >
          <template #activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.i18n ? $t(item.i18n) : item.name" />
            </v-list-item-content>
          </template>
          <!-- 子分类项：缩进 + 小字区分层级 -->
          <v-list-item
            v-for="(child, j) in item.children"
            :key="child.id || child.src || child.i18n || `child-${j}`"
            class="drawer-child-item"
            @click="$router.push(child.src)"
          >
            <v-list-item-title class="drawer-child-title">
              {{ child.name }}
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          :key="`item-${item.id || item.src || item.i18n || index}`"
          :to="item.src"
          :exact="item.exact || false"
          color="primary"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.i18n ? $t(item.i18n) : item.name" />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: 'HomeDrawer',

    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>

<style scoped>
/* 子目录项：左侧缩进增加，字号缩小，颜色偏灰 */
.drawer-child-item {
  padding-left: 32px !important;
  min-height: 38px !important;
}
.drawer-child-title {
  font-size: 0.8rem !important;
  color: rgba(0, 0, 0, 0.55) !important;
  font-weight: 400 !important;
}
</style>
